const e = { aria_label: "Søk", clear: "Fjern", placeholder_article: "", placeholder_header: "Søke etter artikler" }, r = {
  searcher: e
};
export {
  r as default,
  e as searcher
};
//# sourceMappingURL=help-center-articles-search40.js.map
